import api from "PFCore/api";
import { Activity, Collection, EngagementBlueprint, Id, PaginatedCollection, QueryParams } from "PFTypes";

type FetchEngagementBlueprintsParams = Pick<QueryParams, "page" | "perPage"> & {
  term?: string;
};

export const fetchEngagementBlueprints = ({
  page = 1,
  perPage = 25,
  term
}: FetchEngagementBlueprintsParams): Promise<Collection<EngagementBlueprint[]>> =>
  api({
    url: "engagement_blueprints",
    params: { page, perPage, term }
  });

export const fetchEngagementBlueprint = (id: Id): Promise<EngagementBlueprint> =>
  api({
    url: `engagement_blueprints/${id}`
  });

export type EngagementBlueprintActivitiesParams = Pick<QueryParams, "page" | "perPage"> & {
  term?: string;
  subtemplateKey?: string;
};

export const fetchEngagementBlueprintActivities = (
  engagementBlueprintId: Id,
  { page = 1, perPage = 25, subtemplateKey }: EngagementBlueprintActivitiesParams
): Promise<PaginatedCollection<Activity[]>> =>
  api({
    url: `engagement_blueprints/${engagementBlueprintId}/activities`,
    params: { page, perPage, subtemplateKey }
  });
